import Context from './index';
import React, { useState } from 'react';
import request from 'Utils/Helper/Request';

const ReportProvider = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [notificationCount, setNotificationCount] = useState([]);

    /** Filter Notification Count */
    const filterNotificationCount = async (from, to, telco, product_id, user_id) => {
        try {
            setIsLoading(true);
            const response = await request(`${process.env.REACT_APP_MTN_BASE_API_URL}/admin/report/telco-notification-count`, { 
                method: 'POST',
                body: {
                    from: from,
                    to: to, 
                    telco: telco, 
                    product_id: product_id,
                    user_id: user_id
                } 
            });
            setIsLoading(false);
            return response
        } catch (error) {
            setIsLoading(false);
            throw error; 
        }
    };

    /** Filter Request Count */
    const filterRequestCount = async (from, to, telco, product_id, user_id) => {
        try {
            setIsLoading(true);
            const response = await request(`${process.env.REACT_APP_MTN_BASE_API_URL}/admin/report/telco-request-count`, {
                method: 'POST',
                body: {
                    from: from,
                    to: to, 
                    telco: telco, 
                    product_id: product_id,
                    user_id: user_id
                }
            });
            setIsLoading(false);
            return response;
        } catch (error) {
            setIsLoading(false);
            throw error; 
        }
    };
    
    return (
        <Context.Provider
            value={{
                ...props,
                isLoading,
                notificationCount,
                setNotificationCount,
                filterNotificationCount,
                filterRequestCount
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default ReportProvider;